import Button from '@ui/button/Button';
import api from '@utils/api';
import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import Lazyimg from '@components/utils/Lazyimg';
import analytics from '@utils/analytics';
import { useTranslation } from 'react-i18next';
const DiscoveryGallery = (props) => {
    var _a;
    const { t } = useTranslation();
    let fluidIndex = 0;
    const galleryRef = useRef(null);
    const refFluidLoadMore = useRef(null);
    const refGridLoadMore = useRef(null);
    let pageView = sessionStorage.getItem('pageView');
    const webView = (_a = new URLSearchParams(location.search)) === null || _a === void 0 ? void 0 : _a.get('webView');
    const [isGridMode, setIsGridMode] = useState(pageView === 'grid');
    const [totalComponents, setTotalComponents] = useState([]);
    const [totalImages, setTotalImages] = useState([]);
    const [fluidComponents, setFluidComponents] = useState([]);
    const [gridComponents, setGridComponents] = useState([]);
    const [fluidLimit, setFluidLimit] = useState(parseInt(props.fluidTrashold));
    const [gridLimit, setGridLimit] = useState(parseInt(props.gridTrashold));
    const [isLoadng, setIsLoading] = useState(false);
    const infiniteScroll = props.infiniteScroll;
    let fluidIncrement = parseInt(props.fluidTrashold);
    let gridIncrement = parseInt(props.gridTrashold);
    useEffect(() => {
        setIsLoading(true);
        let lastViewedImg = sessionStorage.getItem('lastViewed');
        api.getPageJson(props.pid, true).then((data) => {
            var _a;
            let galleryRegionComponents = (_a = data === null || data === void 0 ? void 0 : data.regions.find((r) => r.id === 'gallery_region')) === null || _a === void 0 ? void 0 : _a.components;
            // LOGIC FOR FLIUD VERSION
            setTotalComponents(galleryRegionComponents);
            setFluidComponents(galleryRegionComponents.slice(0, fluidLimit));
            // LOGIC FOR GRID VERSION
            let gridArray = [];
            galleryRegionComponents.forEach((c) => {
                var _a;
                (_a = c.custom) === null || _a === void 0 ? void 0 : _a.componentsImages.map((images, i) => {
                    React.createElement(React.Fragment, { key: i }, gridArray.push({ images: images }));
                });
            });
            setTotalImages(gridArray);
            setGridComponents(gridArray.slice(0, gridLimit));
            // ON BROWSER BACK LOCIG TO SEE THE LAST VIEWED
            let lastViewedImgInt = parseInt(lastViewedImg, 10);
            if (lastViewedImg) {
                if (isGridMode) {
                    let pageToRender = 1 + Math.floor(lastViewedImgInt / gridIncrement);
                    setGridLimit(gridIncrement * pageToRender);
                }
                else {
                    if (lastViewedImgInt > fluidLimit) {
                        setFluidLimit(lastViewedImgInt + 1);
                    }
                }
                setTimeout(() => {
                    handleGoToLastViewedImg(lastViewedImgInt);
                }, 100);
            }
            else {
                setIsLoading(false);
            }
        });
    }, []);
    React.useEffect(() => {
        if (webView) {
            window.addEventListener('message', (message) => handleAppEvent(message));
            return () => window.removeEventListener('message', (message) => handleAppEvent(message));
        }
    }, []);
    useEffect(() => {
        if (isGridMode) {
            analytics.flpPromotionView(props.pageNameGtm || props.pid, totalImages.length);
        }
        sessionStorage.setItem('pageView', isGridMode ? 'grid' : 'fluid');
        if (infiniteScroll) {
            checkLoadMoreInView();
        }
    }, [isGridMode]);
    useEffect(() => {
        setFluidComponents(totalComponents.slice(0, fluidLimit));
    }, [fluidLimit]);
    useEffect(() => {
        setGridComponents(totalImages.slice(0, gridLimit));
    }, [gridLimit]);
    useEffect(() => {
        if (infiniteScroll) {
            document.addEventListener('scroll', checkLoadMoreInView);
            return () => {
                document.removeEventListener('scroll', checkLoadMoreInView);
            };
        }
    }, []);
    const handleAppEvent = (message) => {
        if (message.data === 'single') {
            setIsGridMode(false);
        }
        else if (message.data === 'grid') {
            setIsGridMode(true);
        }
    };
    const checkLoadMoreInView = () => {
        var _a, _b, _c, _d, _e, _f;
        const rectFluid = (_a = refFluidLoadMore.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        if (rectFluid && rectFluid.top < window.innerHeight && rectFluid.bottom >= 0) {
            // setFluidLimit(fluidLimit + fluidIncrement);
            (_c = (_b = refFluidLoadMore.current) === null || _b === void 0 ? void 0 : _b.querySelector('button')) === null || _c === void 0 ? void 0 : _c.click();
        }
        const rectGrid = (_d = refGridLoadMore.current) === null || _d === void 0 ? void 0 : _d.getBoundingClientRect();
        if (rectGrid && rectGrid.top < window.innerHeight && rectGrid.bottom >= 0) {
            // setGridLimit(gridLimit + gridIncrement);
            (_f = (_e = refGridLoadMore.current) === null || _e === void 0 ? void 0 : _e.querySelector('button')) === null || _f === void 0 ? void 0 : _f.click();
        }
    };
    const handleGoToLastViewedImg = (i) => {
        let image = galleryRef.current.querySelector('[data-index-img="' + i + '"]');
        image === null || image === void 0 ? void 0 : image.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
        sessionStorage.removeItem('lastViewed');
        setTimeout(() => {
            setIsLoading(false);
        }, 800);
    };
    const renderFluidComponents = (custom) => {
        let lastIndex = fluidIndex;
        fluidIndex = fluidIndex + (custom === null || custom === void 0 ? void 0 : custom.componentsImages.length);
        return (React.createElement(React.Fragment, null, custom === null || custom === void 0 ? void 0 : custom.componentsImages.map((images, i) => (React.createElement(React.Fragment, { key: lastIndex + i }, renderFluidImage(images, lastIndex + i))))));
    };
    const renderFluidImage = (images, i) => {
        if (!images) {
            return React.createElement(React.Fragment, null);
        }
        return (React.createElement(React.Fragment, null, images['desktopImage'] && images['desktopImage'].src && (React.createElement(React.Fragment, null, images.link ? (React.createElement("a", { href: images['link'] || '', className: "picture-wrapper", onClick: (e) => pushGTMandClick(images['link'], i, e), "data-index-img": i },
            React.createElement("picture", null,
                images['mobileImage'] && images['mobileImage'].src && React.createElement("source", { media: "(max-width: 768px)", srcSet: images['mobileImage'].src }),
                React.createElement(Lazyimg, { src: images['desktopImage'].src, alt: images['imageAlt'] })))) : (React.createElement("div", { className: "picture-wrapper" },
            React.createElement("picture", null,
                images['mobileImage'] && images['mobileImage'].src && React.createElement("source", { media: "(max-width: 768px)", srcSet: images['mobileImage'].src }),
                React.createElement(Lazyimg, { src: images['desktopImage'].src, alt: images['imageAlt'] }))))))));
    };
    const renderGridImage = (images, i) => {
        if (!images) {
            return React.createElement(React.Fragment, null);
        }
        return (React.createElement(React.Fragment, null, images['desktopImage'] && images['desktopImage'].src && (React.createElement("div", { key: i, className: "grid-tile" }, images.link ? (React.createElement("a", { href: images['link'] || '', className: "picture-wrapper", onClick: (e) => pushGTMandClick(images['link'], i, e), "data-index-img": i },
            React.createElement(Lazyimg, { src: images['tileImage'].src, alt: images['imageAlt'] }))) : (React.createElement("div", { className: "picture-wrapper" },
            React.createElement(Lazyimg, { src: images['tileImage'].src, alt: images['imageAlt'] })))))));
    };
    const pushGTMandClick = (link, i, event) => {
        if (!link || webView) {
            return;
        }
        event.preventDefault();
        if (isGridMode) {
            analytics.discoveryGridClickLink(props.pageNameGtm || props.pid, i);
        }
        else {
            analytics.flpClickLink(props.pageNameGtm || props.pid, i);
        }
        if (event.shiftKey || event.metaKey) {
            window.open(link, '_blank');
        }
        else {
            sessionStorage.setItem('lastViewed', i.toString());
            window.location.href = link;
        }
    };
    return (React.createElement(React.Fragment, null,
        !webView && (React.createElement("div", { className: "actions-bar container" },
            React.createElement(Button, { type: "button", ariaLabel: "Fluid View", ariaCurrent: !isGridMode, cls: ['button--link'], className: classNames('icon--fluid', { active: !isGridMode }), onClick: () => setIsGridMode(false) }),
            React.createElement(Button, { type: "button", ariaLabel: "Grid View", ariaCurrent: isGridMode, cls: ['button--link'], className: classNames('icon--grid', { active: isGridMode }), onClick: () => setIsGridMode(true) }))),
        React.createElement("div", { ref: galleryRef, className: classNames('gallery-section', { fluid: !isGridMode }, { grid: isGridMode }, { loading: isLoadng }) }, !isGridMode ? (React.createElement(React.Fragment, null,
            fluidComponents.map((c) => (React.createElement("div", { key: c.data.ID, className: classNames('discover-image-wrapper', c.type_id.split('_').pop(), c.data.background, { container: c.data.container || c.type_id.split('_').pop() === 'quad' }, { 'no-padding': c.data.noPadding }, { squared: c.data.squared }, { column: c.data.columnInMobile }, { horizontal: c.data.mode === 'horizontal' }) }, renderFluidComponents(c.custom)))),
            fluidComponents.length > 0 && fluidComponents.length !== totalComponents.length && (React.createElement("div", { ref: refFluidLoadMore, className: "load-more-wrapper container" },
                React.createElement("button", { className: "button button--secondary load-more-button", onClick: () => setFluidLimit(fluidLimit + fluidIncrement) }, t('plp.loadmore')),
                React.createElement("p", null,
                    fluidComponents.length,
                    " / ",
                    totalComponents.length))))) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "grid-section" }, gridComponents.map((c, i) => (React.createElement(React.Fragment, { key: i }, renderGridImage(c.images, i))))),
            gridComponents.length > 0 && gridComponents.length !== totalImages.length && (React.createElement("div", { ref: refGridLoadMore, className: "load-more-wrapper container" },
                React.createElement("button", { className: "button button--secondary load-more-button", onClick: () => setGridLimit(gridLimit + gridIncrement) }, t('plp.loadmore')),
                React.createElement("p", null,
                    gridComponents.length,
                    " / ",
                    totalImages.length))))))));
};
export default DiscoveryGallery;
